export default "__VITE_ASSET__Dj9GN78O__"